import { ForgotPasswordPage } from "@shared/features/auth/pages/ForgotPasswordPage";
import {
  PLATFORM_RESET,
  usePlatformDispatch,
} from "@platform//PlatformContext";
import { useClosePlatformAccess } from "@platform/hooks/useClosePlatformAccess";

export function PlatformForgotPasswordPage() {
  useClosePlatformAccess();
  
  const dispatch = usePlatformDispatch();

  const onError = () => {
    dispatch({ type: PLATFORM_RESET });
  };

  return <ForgotPasswordPage onError={onError} />;
}

export default PlatformForgotPasswordPage;
